import React from "react";
import Button from "@mui/material/Button";
import Toolbar from "@mui/material/Toolbar";


function DataComponentButtonToolbar({componentSelected, deactivateClick, activateClick, setUploadDialogOpen}) {

    return (
        <>
            <Toolbar>
                {componentSelected && componentSelected.id ? (
                    componentSelected?.deactivated ? (
                        <>
                            <Button
                                onClick={(event)=>activateClick(event)}
                                color="inherit"
                                variant="outlined"
                                size="medium"
                            >
                                Aktivieren
                            </Button>
                            <Button
                                onClick={()=>setUploadDialogOpen(true)}
                                color="inherit"
                                variant="outlined"
                                size="medium"
                            >Upload</Button>
                        </>
                    ) : (
                        <>
                            <Button
                                onClick={(event)=>deactivateClick(event)}
                                color="inherit"
                                variant="outlined"
                                size="medium"
                            >
                                Deaktivieren
                            </Button>
                            <Button
                                onClick={()=>setUploadDialogOpen(true)}
                                color="inherit"
                                variant="outlined"
                                size="medium"
                            >Upload</Button>
                        </>
                    )
                ):null}

            </Toolbar>
        </>
    )
}

export default DataComponentButtonToolbar;
